module.exports = __webpack_public_path__ + "static/media/hcp-levels-table.5b4e1876.svg";